const bg = {
  "Home": "Начало",
  "Add": "Добави",
  "Edit": "Промени",
  "Adding": "Добавяне на",
  "Editing": "Редактиране на",
  "Delete": "Изтрий",
  "Save": "Запис",
  "Cancel": "Отказ",
  "Close": "Затвори",
  "Open": "Отвори",
  "Users": "Потребители",
  "Are you sure you want to logout": "Сигурни ли сте, че искате да излезете?",
  "Name": "Име",
  "Password": "Парола",
  "Email": "Електронна поща",
  "Active": "Активен",
  "UserIsActive": "Потребителят е активен",
  "Filter": "Филтрирай",
  "Clear": "Изчисти",
  "Code": " Код",
  "Actions": "Действия",
  "Confirm Dialog": "Диалог за потвърждение",
  "User": "Потребител",
  "Are you sure that you want to delete": "Сигурни ли сте, че искате да изтриете",
  "Role": "Роля",
  "Region": "Регион",
  "Administrator": "Администратор",
  "ProductManager": "Мениджър на продукти",
  "RegionalManager": "Регионален мениджър",
  "Trader": "Търговец",
  "1000": "Потребителят не е намерен",
  "1001": "Имейлът вече съществува",
  "1002": "Моля въвдете имейл",
  "1003": "Моля въвдете парола",
  "1004": "Моля въвдете име",
  "1005": "Моля въвдете роля",
  "1006": "Моля въвдете регион",
  "1007": "Моля въведете текуща парола",
  "1008": "Текущата парола е грешна",
  "Yes": "Да",
  "No": "Не",
  "Login": "Вход",
  "Please enter email": "Моля въведете електронна поща.",
  "Please enter Password": "Моля въведете парола.",
  "Invalid E-mail or Password.": "Невалиден имейл адрес или парола.",
  "Invalid E-mail.": "Невалиден имейл адрес.",
  "Not found E-mail.": "Невалиден имейл адрес или парола.",
  "Result": "Резултати",
  "Logout": "Изход",
  "Products": "Продукти",
  "Accessories": "Аксесоари",
  "Offers": "Оферти",
  "You are not Authenticated to view this resource": "Нямате права за достъп до този ресурс.",
  "RepeatPassword": "Повторете паролата",
  "Please enter name": "Моля въведете име.",
  "Please enter password": "Моля въведете парола.",
  "Please repeat password": "Моля повторете въведената парола.",
  "Please select a role": "Моля изберете роля.",
  "Please select a region": "Моля изберете регион.",
  "Passwords dont match": "Въведените пароли не съвпадат.",
  "AddUser": "Добавяне на потребител",
  "EditUser": "Редактиране на потребител",
  "Profile": "Профил",
  "CurrentPassword": "Текуща парола",
  "NewPassword": "Нова парола",
  "Change": "Промени",
  "FillCurrentPassword": "Моля въведете текуща парола",
  "FillNewPassword": "Моля въведете нова парола",
  "Password successfully changed": "Паролата беше променена успешно.",
  "Change password": "Промени парола",
  "Regions": "Региони",
  "Configuration": "Конфигурация",
  "AddRegion": "Добавяне на регион",
  "EditRegion": "Редактиране на регион",
  "RegionIsActive": "Региона е активен",
  "Categories": "Категории",
  "AddCategory": "Добави категория",
  "EditCategory": "Редактиране на категория",
  "RootCategory": "Онсовна",
  "ChildCategory": "Дете",
  "MainCategory": "Основна",
  "SubCategory": "Подкатегория",
  "2000": "Моля, въведете име на регион",
  "2001": "Регионът не е намерен",
  "2002": "Моля, въведете име на категория",
  "2003": "Категорията не е намерен",
  "Add product": "Добавяне на продукт",
  "Edit product": "Редактиране на продукт",
  "Main info": "Основна информация",
  "Installation activities": "Монтажни дейности",
  "Fasteners": "Материали в услуга",
  "Characteristics": "Характеристики",
  "Article number": "Артикулен номер",
  "Brand": "Марка",
  "Model": "Модел",
  "Category": "Категория",
  "Price": "Цена (лв.)",
  "Single price": "Ед. цена (лв.)",
  "Discount": "Отстъпка (%)",
  "Description": "Описание",
  "There are no installation activities added": "Няма добавени монтажни дейности.",
  "There are no fasteners added": "Няма добавени материали в услугата.",
  "Add installation activity": "Добавяне на монтажна дейност",
  "Edit installation activity": "Редактиране на монтажна дейност",
  "Add fastener": "Добавяне на крепежен елемент",
  "Edit fastener": "Редактиране на крепежен елемент",
  "Please add description": "Моля въведете описание.",
  "Please add price": "Моля въведете цена.",
  "Please add article number": "Моля въведете артикулен номер.",
  "Please add article name": "Моля въведете име на артикула.",
  "Please select category": "Моля изберете категория.",
  "Please add brand": "Моля въведете марка.",
  "3000": "Моля въведете марка на продукта",
  "3001": "Всички монтажни дейности трябва да имат описание.",
  "3002": "Всички крепежни елементи трябва да имат описание.",
  "3003": "Продуктът не е намерен.",
  "Deactivate": "Деактивирай",
  "2004": "Клиентът не е намерен",
  "2005": "Моля, въведете име на клиент",
  "4000": "Офертата не е намерена",
  "4001": "Моля, въведете дата на оферта",
  "Status": "Статус",
  "OfferNumber": "Номер на оферта",
  "OfferDate": "Дата на оферта",
  "TraderName": "Име на търговец",
  "ManagerName": "Име на мениджър",
  "ClientName": "Име на клиент",
  "City": "Град",
  "Address": "Адрес",
  "BoilerMake": "Котел",
  "InCreate": "Създава се",
  "NewOffer": "Нова",
  "InProcess": "Изпълнява се",
  "Completed": "Приключена",
  "TimePeriod": "Времеви интервал",
  "Administration": "Администрация",
  "All": "Всички",
  "Actives": "Активни",
  "NotActives": "Неактивни",
  "3004": "Съществува продукт с въведения артикулен номер.",
  "Power": "Мощност",
  "offer": "оферта",
  'DateFormat': 'dd.MM.yyyy г.',
  'Client': 'Клиент',
  'Total': 'Общо (лв.)',
  'Notes': 'Бележки',
  'EditOffer': 'Редактиране оферта',
  'AddOffer': 'Добави оферта',
  'Settlement': 'Населено място',
  'Month': 'Месец',
  'Quarter': 'Тримесечие',
  'Year': 'Година',
  "Manager": "Мениджър",
  "Number": "Номер",
  "Date": "Дата",
  "Phone": "Телефон",
  "Edit user data": "Редакция на потребителски данни",
  "Profile data succesfully saved": "Потребителските данни бяха записани успешно.",
  "Supplier": "Доставчик",
  "Article": "Артикул",
  "AndAllItsSubcategories": "и всички нейни подкатегории",
  "NoRecordsFound": "Няма намерени записи",
  "NewUser": "Нов потребител",
  "NewRegion": "Нов регион",
  "NewCategory": "Нова категория",
  "Articles": "Артикули",
  "NewArticle": "Нов артикул",
  "EditArticle": "Редактиране на артикул",
  "PriceTo": "Цена до (лв.)",
  "Are you sure that you want to delete/deactivate": "Сигурни ли сте, че искате да изтриете/деактивирате",
  "UnitNumber": "брой",
  "UnitLinearMeter": "л.м.",
  "Unit": "Мерна единица",
  "3005": "Моля изберете мерна единица.",
  "Please select a unit": "Моля изберете мерна единица.",
  "Period": "Период",
  'Deleted Successfully': "Изтриването беше успешно",
  'Data Saved Successfully': "Данните бяха записани успешно",
  '2006': "Регионът е закачен към потребители. Изтриването неуспешно!",
  '2007': "Категорията е закачена към артикули. Изтриването неуспешно!",
  '1009': "Потребителят има оферти. Изтриването неуспешно!",
  '3006': "Артикулът е закачен. Изтриването неуспешно!",
  '4002': "Офертата е закачена. Изтриването неуспешно!",
  'ChoosePeriod': 'Избери период',
  'DateFrom': 'Дата от',
  'DateTo': 'Дата до',
  'CustomPeriod': 'Въведи период',
  "Package": "Пакет",
  "Article search": "Търсене на артикул...",
  "No records found": "Няма намерени резултати",
  "Qty": "к-во",
  "Product is already added": "Избрания артикул вече е добавен!",
  "No products added to the package": "Няма добавени артикули към пакета.",
  "The quantity entered for the related article": "Въведеното количество за свързан артикул",
  "is not valid": "е невалидно",
  "Articles in package": "Артикули в пакет",
  "UnitShort": "м. ед.",
  "Email address is not valid": "Въведената електронна поща е невалидна.",
  "Product price is not valid": "Въведената цена е невалидна.",
  'DateTimeFormat': "dd.MM.yyyy г. HH:mm ч.",
  'StartDate': 'Начална дата',
  'EndDate': 'Крайна дата',
  'DateFormatUS': 'dd.MM.yyyy г.',
  'From': 'От',
  'To': 'До',
  'ContractAgreed': 'Сключен договор',
  'ContractCompleted': 'Приключен договор',
  '1010': "Вече съществува активен регионален мениджър в този регион!",
  'NumberOfActiveUsers': 'Брой активни потребители',
  'NumberOfActiveArticles': 'Брой активни артикули',
  'NumberOfActiveOffers': 'Брой активни оферти',
  'NumberOfActiveRegions': 'Брой активни региони',
  'NumberOfActiveCategories': 'Брой активни категории',
  'NumberOfUsers': 'Брой потребители',
  'NumberOfArticles': 'Брой артикули',
  'NumberOfOffers': 'Брой оферти',
  'NumberOfRegions': 'Брой региони',
  'NumberOfCategories': 'Брой категории',
  "from total": "от общо",
  'Offer': 'Оферта',
  'BillOfQuantities': 'Количествена сметка',
  'AxonometricDiagramGas': 'Аксонометрична схема на газова инсталация',
  'AxonometricDiagramHeat': 'Аксонометрична схема на топлинна инсталация',
  'Files': 'Файлове',
  'AllowedFormats': 'Позволени формати',
  'MaxTotalFileSize': 'Макс. общ размер на файловете',
  'Download': 'Изтегли',
  'AddFiles': 'Добавете файлове',
  'Remove': 'Премахни',
  'file': 'файл',
  'GasInstallation': 'Газова инсталация',
  'HeatInstallation': 'Водно-отоплителна инсталация',
  'Device': 'Уред',
  'DevicePackage': 'Уред пакет',
  'Service': 'Услуга',
  'Equipment': 'Оборудване',
  'AncillaryEquipment': 'Спомагателно оборудване',
  'Type': 'Тип',
  '2008': 'Файлът не е намерен',
  'Devices': 'Уреди',
  'Services': 'Услуги',
  'Packages': 'Пакети',
  'Materials': 'Материали',
  'type': 'тип',
  'Categories without type. Please add type to all categories.': 'Има категории без присвоен тип. Моля, добавете тип към всички категории.',
  'Types': 'Типове',
  "CreatedOn": "Създаден",
  '4004': "Офертата е в процес на изпълнение и не може да бъде изтрита",
  "ToPrice": "До цена (лв.)",
  "HeatingInstallation": "Отоплителна инсталация",
  "Price without VAT": "Цена без ДДС",
  "Total without VAT": "Общо без ДДС",
  "Total after discount": "Обща сума след отстъпка без ДДС",
  "VAT": "ДДС",
  "Disctrict": "Област",
  "Total with VAT": "Общо с ДДС",
  "Radiators": "Радиатори",
  'Please select type': 'Моля изберете тип',
  '2010': "Регионът е закачен към активни потребители. Деактивирането неуспешно!",
  "3007": "Възникна проблем със зареждането на графичните знаци.",
  "Choose": "Избери",
  "No graphical elements added": "Няма добавени графични елементи.",
  "Select graphical element": "Избор на графичен елемент",
  "Choose trader": "Изберете търговец.",
  "Disclaimer": "Забележки",
  "cauldron": "котел",
  "radiator": "радиатор",
  "kitchen": "печка",
  "void": "празнина",
  "hot-plate": "котлон",
  "lyre": "лира",
  "smoke-extractor": "димоотвод",
  "boiler": "бойлер",
  "convector": "конвектор",
  "default": "по подразбиране",
  "Price from supplier": "Цена от доставчик (лв.)",
  "Labor": "Труд",
  "Labor in service": "Труд в услуга",
  "No labor added in service": "Няма добавен труд в услугата.",
  "without vat": "без ДДС",
  "Pipes": "Тръби",
  "Diameter": "Диаметър (мм)",
  "Kits": "Китове",
  "Articles in kit": "Артикули в кит",
  "Discount amount without VAT": "Сума на отстъпка без ДДС",
  "Status changes": "История на статусите",
  "magnet-ventil": "магнет вентил",
  "triple": "тройник",
  "coupling": "муфа",
  "ventil": "вентил",
  "elbow": "коляно",
  "New": "Нова",
  "Expired": "Изтекла",
  "Accepted": "Приета",
  "InExecution": "В изпълнение",
  "Finished": "Приключена",
  "Changed by system": "Системна промяна",
  "w/о VAT": "без ДДС",
  "MaxPrice": "Максимална цена (BGN)",
  "gasBoiler": "котел",
  "towelRail": "лира",
  "tee": "тройник",
  "Registered": "Създаден",
  "System": "Системни",
  "Logs": "Логове",
  "View": "Преглед",
  "View last": "Свали последния файл",
  "No files detected": "Няма намерени файлове",
  "View current": "Свали избрания файл",
  "No file selected": "Няма избран файл",
  'Can not view directories!': 'Не могат да се преглеждат директории!',
  '1011': 'Потребителят не е аутентикиран',
  "PriceFromSupplier": "Доставна цена (лв.)",
  "Power1": "Мощност 1",
  "Power2": "Мощност 2",
  "Recalculate Offer": "Преизчисли оферта",
  "Recalculate": "Преизчисли",
  "Recalculate dialog": "Преизчисляване на оферта",
  "Change in offer data.": "Има промяна в данните на офертата.",
  "Please contact trader or regional manager": "Моля, свържете се с търговец или регионален мениджър",
  "Please contact trader": "Моля, свържете се с търговец",
  "or his regional manager.": "или регионалния мениджър, за да преизчисли офертата и генерира файловете.",
  "Cauldrons": "Котли",
  "Stoves": "Печки",
  "Flues": "Димоотводи",
  "Boilers": "Бойлери",
  "TowelRails": "Лири",
  "Convectors": "Конвектори",
  "steel-radiator": 'стоманен радиатор',
  "Discount (BGN)": "Отстъпка (лв.)",
  "Transfer": "Прехвърли",
  "TransferOffers": "Прехвърляне на оферти",
  'Choose atleast one offer to transfer': 'Моля, изберете поне една оферта за прехвърляне.',
  "Save & Close": "Запази и затвори",
  "Can not trasnfer finished offers!": "Не може да прехвърляте приключени оферти!",

  "of": "от",
  "Client information": "Информация за клиента",
  "GasInstallPrice": "Газова инсталация (общо без ДДС)",
  "HeathInstallPrice": "Отоплителна инсталация (общо без ДДС)",
  "BGN": "лв.",
  "Signature": "Подпис",
  "Sales Representative": "Търговски представител",
  "Phone for contact": "Телефон за контакти",
  "Accept the offer": "Приемам предложението",
  "Installation": "Инсталация",
  "Validity of the proposal": "Валидност на предложението",
  "to": "до",
  "Services and materials": "Монтажни услуги и материали",
  "PriceOnly": "Цена",
  "ArticleNumber": "Артикулен номер",
  "SentToClient": "Изпратена"
}

export default bg;